module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-380.ad18499.woff2";